import { render, staticRenderFns } from "./urea.vue?vue&type=template&id=a98fb2de&scoped=true&"
import script from "./urea.vue?vue&type=script&lang=js&"
export * from "./urea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98fb2de",
  null
  
)

export default component.exports